<script>import { Default } from "@cf/ui-lib/icons";
export let src = "";
export let alt = "";
let flag = false;
$: if (src) flag = true;
</script>

<img {...$$restProps} src={flag ? src : Default} alt={alt} on:error={() => {flag=false}} />
